import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type ResolvedContactFormSubject } from '../../model/directContactFormSubjectPolicySelectors'

import { DirectContactFormTextField } from './DirectContactFormTextField'

export const DirectContactFormProductCodeField: FC<{
  clearErrorOnClick?: boolean
  isPrefilled?: boolean
  resolvedSubject: ResolvedContactFormSubject
}> = ({ clearErrorOnClick, isPrefilled, resolvedSubject }) => {
  const intl = useIntl()
  const { productCodeRequirement } = resolvedSubject.policy
  const shouldShowProductCode = productCodeRequirement !== 'hidden'

  if (isPrefilled || !shouldShowProductCode) {
    return null
  }

  const isProductCodeRequired = productCodeRequirement === 'required'

  return (
    <DirectContactFormTextField
      clearErrorOnClick={clearErrorOnClick}
      data-qa-id="contact-form-productCode"
      label={intl.formatMessage({
        id: 'direct.contact.form.productName.placeholder.text',
      })}
      name="productCode"
      required={isProductCodeRequired}
      rules={{
        required:
          isProductCodeRequired &&
          intl.formatMessage({
            id: 'form.error.input.missing',
          }),
      }}
    />
  )
}
